export enum ServerType {
  Main = 'main',
  Server = 'server',
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/games/models/server-type.model.ts